// extracted by mini-css-extract-plugin
module.exports = {"container":"_35XnW6PJKFuCfmeaENGIM9"};